var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.885 5.669l-.555-.554a.394.394 0 00-.556 0l-3.689 3.681A9.399 9.399 0 0016 6.568c-5.207 0-9.429 4.213-9.429 9.41 0 2.317.843 4.434 2.233 6.074l-3.69 3.681a.392.392 0 000 .555l.556.554a.394.394 0 00.556 0l3.689-3.682A9.397 9.397 0 0016 25.39c5.207 0 9.429-4.213 9.429-9.41a9.357 9.357 0 00-2.233-6.073l3.69-3.682a.392.392 0 000-.555zM8.143 15.979c0-4.324 3.525-7.842 7.857-7.842 1.883 0 3.59.692 4.945 1.798l-11 10.978c-1.11-1.352-1.802-3.055-1.802-4.934zm15.714 0c0 4.323-3.525 7.841-7.857 7.841-1.883 0-3.59-.692-4.945-1.798l11-10.978c1.11 1.352 1.802 3.055 1.802 4.934z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b38778f8910719eeb29e86e371223ec7.svg";
export { ForwardRef as ReactComponent };